<template>
    <v-btn :id="Title.replaceAll(' ', '')" :name="Title" :width="width" :variant="variant"
        :class="CustomClass ? CustomClass : 'v-btn1'" :disabled="loader || disable" @click="ClickFun" >
        <div v-if="!svg">
            <slot name="logo" />
        </div>
        <div v-else>
            <svg v-if="(svg == 1)" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4"
                    d="M16.1917 2H7.82173C4.18173 2 2.01172 4.17 2.01172 7.81V16.18C2.01172 19.82 4.18173 21.99 7.82173 21.99H16.1917C19.8317 21.99 22.0017 19.82 22.0017 16.18V7.81C22.0017 4.17 19.8317 2 16.1917 2Z"
                    fill="#fff" />
                <path
                    d="M9.17156 14.0919C9.36156 14.0919 9.55155 14.0219 9.70155 13.8719L14.0816 9.49187V11.9219C14.0816 12.3319 14.4216 12.6719 14.8316 12.6719C15.2416 12.6719 15.5816 12.3319 15.5816 11.9219V7.68188C15.5816 7.58188 15.5616 7.49188 15.5216 7.39188C15.4416 7.21188 15.3016 7.06188 15.1116 6.98188C15.0216 6.94188 14.9216 6.92188 14.8216 6.92188H10.5816C10.1716 6.92188 9.83156 7.26188 9.83156 7.67188C9.83156 8.08187 10.1716 8.42188 10.5816 8.42188H13.0116L8.63156 12.8019C8.34156 13.0919 8.34156 13.5719 8.63156 13.8619C8.79156 14.0219 8.98156 14.0919 9.17156 14.0919Z"
                    fill="#fff" />
                <path
                    d="M18.7107 16.2819C18.5807 15.8919 18.1607 15.6819 17.7607 15.8119C14.0407 17.0519 9.95066 17.0519 6.23066 15.8119C5.84066 15.6819 5.41067 15.8919 5.28067 16.2819C5.15067 16.6719 5.36067 17.1019 5.75067 17.2319C7.76067 17.9019 9.87067 18.2419 11.9907 18.2419C14.1107 18.2419 16.2207 17.9019 18.2307 17.2319C18.6307 17.0919 18.8407 16.6719 18.7107 16.2819Z"
                    fill="#fff" />
            </svg>
            <svg v-if="(svg == 2)" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4"
                    d="M21 7V17C21 20 19.5 22 16 22H9C10.21 21.09 11 19.63 11 18C11 15.24 8.76 13 6 13C4.87 13 3.83 13.37 3 14V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
                    fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14.5 3.75C14.9142 3.75 15.25 4.08579 15.25 4.5V6.5C15.25 7.18579 15.8142 7.75 16.5 7.75H18.5C18.9142 7.75 19.25 8.08579 19.25 8.5C19.25 8.91421 18.9142 9.25 18.5 9.25H16.5C14.9858 9.25 13.75 8.01421 13.75 6.5V4.5C13.75 4.08579 14.0858 3.75 14.5 3.75Z"
                    fill="white" />
                <path
                    d="M6 13C3.24 13 1 15.24 1 18C1 20.76 3.24 23 6 23C8.76 23 11 20.76 11 18C11 15.24 8.76 13 6 13ZM5.16 19.27C5.41 19.52 5.41 19.93 5.16 20.19C5.03 20.32 4.87001 20.38 4.70001 20.38C4.53001 20.38 4.36999 20.32 4.23999 20.19L2.51001 18.46C2.26001 18.21 2.26001 17.8 2.51001 17.54L4.23999 15.81C4.48999 15.56 4.9 15.56 5.16 15.81C5.41 16.06 5.41 16.47 5.16 16.73L3.89001 18L5.16 19.27ZM9.48001 18.46L7.75 20.19C7.62 20.32 7.46001 20.38 7.29001 20.38C7.12001 20.38 6.95999 20.32 6.82999 20.19C6.57999 19.94 6.57999 19.53 6.82999 19.27L8.10001 18L6.82999 16.73C6.57999 16.48 6.57999 16.07 6.82999 15.81C7.07999 15.56 7.49 15.56 7.75 15.81L9.48001 17.54C9.73001 17.8 9.73001 18.2 9.48001 18.46Z"
                    fill="white" />
            </svg>
            <svg v-if="(svg == 3)" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="28" height="28"
                viewBox="0 0 48 48">
                <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"></path>
                <path fill="#FFF"
                    d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z">
                </path>
                <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"></path>
                <path fill="#FFF"
                    d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z">
                </path>
            </svg>
            <svg v-if="(svg == 4 )" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" width="28"
                height="28">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="#FFFFFF"
                    d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
            <svg v-if="(svg == 5)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28">
                <path fill="currentColor"
                    d="M21.6 10.8c-1.2-4-4.8-6.8-9.2-6.8-1.6 0-3.2 0.4-4.6 1.2l1.3 2.4c0.8-0.4 1.6-0.6 2.5-0.6 3.4 0 6.4 2.6 6.8 6h2.9l-4 4-4-4h3.1c-0.4-2.5-2.6-4.4-5.3-4.4s-4.9 2-5.3 4.5c-0.4 2.7 1.5 5.2 4.2 5.6 0.7 0.1 1.4 0 2.1-0.2l1.3 2.3c-1.2 0.5-2.6 0.8-4 0.8-4.5 0-8.3-3.6-8.3-8s3.8-8 8.3-8c4.3 0 7.9 3.3 8.3 7.5z" />
            </svg>
            <svg v-if="(svg == 6)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-plus">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>

        </div>
        <span :style="svg ? 'margin-left: 8px' : ''">{{ Title }}</span>
        <span v-if="loader">
            <v-progress-circular indeterminate :size="30" bg-color="black"></v-progress-circular>
        </span>
    </v-btn>
</template>
<script>
export default {
    name: "genericBtnComponent",
    props: {
        CustomClass: { default: null },
        ClickFun: { type: Function },
        width: {},
        Title: {
            type: String,
            default: ""
        },
        svg: {
            type: String,
            default: null
        },
        backgroundColor: {
            type: String,
            default: "#114EF7"
        },
        color: {
            type: String,
            default: "#fff"
        },
        height: {
            type: String,
            default: "45px"
        },
        fontWeight: {
            type: [String, Number],
            default: 600
        },
        variant: {
            type: String,
            default: null
        },
        loader: {
            type: Boolean,
            default: false,
        },
        disable: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
<style scoped>
.v-btn1 {
    font-family: 'Inter';
    font-style: normal;
    letter-spacing: 1px;
    font-size: 14px;
    line-height: 29px;
    height: v-bind(height);
    background: v-bind(backgroundColor);
    font-weight: v-bind(fontWeight);
    color: v-bind(color);
    display: flex;
    flex-direction: column;
    padding: 8px 12px 8px 12px;
    border-radius: 12px;
}

div {
    padding-bottom: 3px
}

.loader-color {
    color: #001e50;
}
</style>